var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteIconFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2.84534V5.8335H13.4882L10.5 2.84534ZM13.8333 7.50016H10.5C9.57952 7.50016 8.83333 6.75397 8.83333 5.8335V2.50016H2.16667V17.5002H13.8333V7.50016ZM2.16667 0.833496H10.8452L15.5 5.48832V17.5002C15.5 18.4206 14.7538 19.1668 13.8333 19.1668H2.16667C1.24619 19.1668 0.5 18.4206 0.5 17.5002V2.50016C0.5 1.57969 1.24619 0.833496 2.16667 0.833496ZM4.66667 14.1668V12.5002H9.66667V14.1668H4.66667ZM4.66667 10.8335V9.16683H11.3333V10.8335H4.66667Z",
    fill: "#8139d0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIconFill);
export default __webpack_public_path__ + "static/media/note-icon-fill.f1f85e5e3f63d48fd884a9a67d2d4d2f.svg";
export { ForwardRef as ReactComponent };